export default {
  live_center: "直播中心",
  virtual_games: "虚拟游戏",
  support: "客户服务",
  bet_limit: "投注限额",
  favorites: "我的最愛",
  note: "注意",
  running: "进行中",
  my_bets: "我的投注",
  my_account: "我的帐户",
  contact_us: "联系我们",
  report: "报告",
  help_support: "帮助支持",
  currency: "货币",
  others: "其他",
  welcome: "欢迎",
  password: "密码",
  sports: "体育博彩",
  my_sports: "体育",
  casino: "真人娱乐场",
  mini_casino: "迷你真人娱乐场",
  games: "游戏",
  esports: "电子竞技",
  esports2: "电子竞技",
  e_sports: "电子竞技",
  keno: "奇乐",
  lottery: "乐透",
  mobile: "智能手机",
  login: "登录",
  logout: "登出",
  bet_credit: "投注额度",
  given_credit: "信用额度",
  cash_balance: "现金余额",
  outstanding: "未结束投注",
  nickname: "昵称",
  last_login: "最后登录",
  last_transaction: "最后交易",
  password_expiry: "密码过期",
  edit: "编辑",
  show_balance: "显示余额",
  bet_list: "投注历史",
  statement: "帐目",
  result: "赛果",
  message: "信息",
  settings: "设置",
  search_team: "搜索队名",
  hide_header: "隐藏标题",
  show_header: "显示标题",
  live_streaming: "即时直播",
  live_tv: "即时直播",
  live_match: "实时比赛动态",
  account_id: "帐户ID",
  submit: "提交",
  change_account_password: "更改帐户密码",
  current_password: "当前密码",
  new_password: "新密码",
  confirm_new_password: "确认新密码",
  set_nickname: "设置昵称",
  account: "帐户",
  bet_slip: "投注单",
  my_bet: "我的投注",
  my_favorites: "我的最愛",
  live: "滚球",
  all_sports: "所有运动",
  early: "早盘",
  today: "今日赛事",
  parlay: "混合过关",
  new: "更新",
  single: "单笔投注",
  amount: "額",
  amount_before_balance: "餘額前",
  amount_after_balance: "餘額後",
  inplay: "实时比赛",
  booster: "Boost",

  page_display: "页面显示",
  customize_sports_order: "自订体育赛事顺序",
  betting: "投注",
  action: "行动",
  save: "保存",
  display_language: "显示语言",
  odds_type: "赔率类型",
  page_type: "页面类型",
  page_size: "页面",
  show_score_map: "显示盈利预测图",
  default_event_sorting: "默认赛事排序",
  event_sorting: "赛事排序",
  market_type: "盘口类型",
  restore: "恢复",
  default_stake: "默认注金",
  accept_better_odds: "自动接收较佳赔率",
  accept_any_odds: "自动接收任何赔率",
  auto_refresh_odds: "自动刷新赔率",
  auto_refresh: "自动刷新",
  auto_refreshing: "自动刷新中。。。",
  date: "日期",
  choice: "选择",
  odds: "赔率",
  stake: "投注金额",
  status: "状态",
  sort: "分类",
  note: "注意",
  remark: "备注",
  turnover: "交易额",
  valid_turnover: "有效交易额",
  credit: "支出",
  debit: "收入",
  commission: "佣金",
  balance: "余额",
  betting_statement: "投注帐目",
  opening_balance: "前期余额",
  sportsbook: "体育博彩",
  livecasino: "真人娱乐场",
  bet_types: "投注类型",
  bet_type: "投注类型",
  event: "赛事",
  yesterday: "昨日赛事",
  outright: "优胜冠军",
  kickoff: "开赛",
  time: "时间",
  match: "赛事",
  first_half: "上半场比分",
  final: "最后赛果",
  first_5_inn: "First 5 Innings",
  team: "队名",
  bs: "上/下",
  oe: "单/双",
  sum: "总数",
  group: "组合",
  "no/": "编号",
  on: "开",
  off: "关",
  message_history: "最新讯息",
  normal_announcements: "一般公告",
  special_announcements: "特殊公告",
  personal_message: "个人讯息",
  to: "到",
  outstanding_bet: "未完成交易",
  trans_time: "交易时间",
  win: "赢",
  loss: "输",
  draw: "和局",
  draw_cancel: "和局",
  bet_summary: "投注摘要",
  bet_reject: "投注作废",
  ref_no: "参考编号",
  lost: "输",
  lose: "输",
  lose_all: "全输",
  lose_half: "输半",
  won: "赢",
  won_all: "全赢",
  won_half: "赢半",
  subtotal: "小计",
  total: "总数",

  dec: "欧洲盘",
  hk: "香港盘",
  my: "马来盘",

  double_line: "双线双盘口",
  single_line: "单线单盘口",
  full_time: "全场",
  half_time: "半场",
  enable: "启用",
  disable: "不启用",
  normal_sorting: "普通排序",
  sort_by_time: "按时间排序",

  market: "盘口",
  all_markets: "全部盘口",
  main_markets: "主要盘口",
  other_markets: "其他盘口",

  main: "主要盘口",
  corners: "角球/罚牌",
  specials: "特别产品",

  dec_odds: "欧洲盘",
  hk_odds: "香港盘",
  my_odds: "马来盘",

  last_bet: "最后投注",
  customize: "自订",
  slots: "老虎机",
  mini_slots: "迷你老虎机",

  quick_bet: "快速投注",
  quick_bet_stake: "快速投注金额",
  select_leagues: "选择联赛",

  cancel: "取消",
  process_bet: "下注",
  add_to_parlay: "加入混合过关",
  add_to_booster: "加入Booster",
  remove_from_parlay: "從混合过关移除",
  remove_from_booster: "移除 Booster",

  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  sunday: "星期日",

  min: "最低投注",
  max: "最高投注",
  payout: "贏取金額",
  max_payout: "最高贏取金額",

  accepted: "已接受",
  bets: "投注",
  bet: "投注",
  waiting: "等待中",
  void: "已作废",
  reject: "取消",
  rejected: "取消",

  yes: "是",
  no: "否",

  all_league: "所有联赛",
  match_completed: "已完场",
  match_pending: "赛事待定",
  match_cancelled: "退款",
  match_cancelled_1h: "上半场退款",
  match_cancelled_2h: "下半场退款",
  match_suspended: "赛事终止",
  match_suspended_1h: "上半场终止",
  match_suspended_2h: "下半场终止",

  over: "大",
  under: "小",
  home: "主",
  away: "客",
  odd: "单",
  even: "双",

  check_all: "全选",
  selected_only: "只显示已勾选",
  filtered: "筛选",
  turn_on: "开启功能",
  turn_off: "关闭功能",
  transaction_date: "交易日期",
  transfer_method: "轉送方法",
  transfer: "转账",

  goal: "进球",
  id_odds: "印尼盘",
  clear_filter: "清除筛选",

  preference: "我的喜好",
  closing_balance: "结帐余额",
  settled_amount: "已結算",

  hdp: "让球",
  ou: "大/小",
  oe: "单/双",
  oxt: "独赢",
  ml: "独赢",
  market_1: "早盘",
  market_2: "今日赛事",
  market_3: "滚球",

  moneyline: "独赢",

  rules_regulations: "規則",
  rules: "規則",
  events: "特别活动",

  processing: "处理中...",

  big_small: "大/小",
  odd_even: "单/双",

  first_digit: "第一位数字",
  second_digit: "第二位数字",
  third_digit: "第三位数字",
  forth_digit: "第四位数字",
  total_4d: "4D 总数",
  total_3d: "后3D总数",
  total_1st2d: "第一2D总数",
  total_last2d: "最后2D总数",

  official_link: "官方链接",

  prize1: "首奖",
  prize2: "二奖",
  prize3: "三奖",

  round1: "第一回合",
  round2: "第二回合",
  round3: "第三回合",
  round4: "第四回合",
  round5: "第五回合",

  map1: "地图一",
  map2: "地图二",
  map3: "地图三",
  map4: "地图四",
  map5: "地图五",
  map6: "地图六",
  map7: "地图七",
  map8: "地图八",
  map9: "地图九",
  map10: "地图十",

  ftmode0: "全部",
  ftmode9: "接下来2小时",
  ftmode1: "接下来4小时",
  ftmode2: "接下来8小时",
  ftmode3: "现在 ~ 00:00",
  ftmode4: "00:00 ~ 04:00",
  ftmode5: "04:00 ~ 12:00",

  continue: "继续",

  highlight: "体育亮点",
  all: "全部",
  show_all_time: "显示所有时间",
  back: "返回",
  fishing: "捕鱼",

  upnext: "接下来播放",
  no_video: "没有视频",

  mm_odds: "缅甸盘",
  mmo_parlay: "缅甸混合过关",
  myanmar: "缅甸",

  mini_games: "迷你游戏",

  combo: "组合",

  mix_parlay: "混合过关",

  total_bet: "总注单数",
  total_stake: "总投注额",

  total_match: "赛事总数",
  combination: "组合",
  stakeperbet: "每注赌金",
  total_payout: "最大赢取金额",
  total_accept: "已接受总数",
  total_reject: "取消总数",
  sysparlay: "串关系统",
  abets: "个注单",
  afold: "串1",
  fold: "串一",

  sum_wl: "输赢总数",
  sum_bet: "赌金总数",
  event_euro: "欧洲杯 2024",
  event_copa: "美洲杯 2024",
  event_olympic: "奥运会 2024",
  event_worldcup: "世界杯 2022",

  mini_arcade: "迷你街机",

  abandoned: "弃赛",
  score: "分数",
  winner: "优胜者",

  upcoming: "即将到来",
  ko: "取胜方式",

  lucky_pick: "过关生成器",
  random_pick: "生成",
  add_pick: "添加到投注单",

  tournament: "锦标赛",
  tournament2: "锦标赛+",
  create_room: "创建房间",
  create_private_room: "创建私人房间",
  search_room: "搜索房间",
  join_now: "立即加入",
  entry_fee: "入场费",
  pool: "奖池 $",
  room: "房间",
  matches: "场次",
  private: "私人",
  public: "公开",
  select_matches: "选择场次",
  selected: "已选择",
  tomorrow: "明天",
  room_rate: "房间费率",
  room_limit: "房间限制",
  room_password: "PIN",
  join_room: "加入房间",
  enter_room: "进入房间",
  leave_room: "离开房间",
  joined_only: "仅限已加入",
  last_betting_time: "最后下注时间",
  owner: "房主",
  room_id: "房间ID",
  points: "积分",
  total_points: "总积分",
  refresh: "刷新",
  details: "详情",
  bet_id: "注单ID",
  room_status: "房间状态",
  winner_rank: "获胜排名",
  players: "玩家",
  rank_show: "获胜排名",
  rank_hide: "投注赛果",
  refund: "退款",
  player: "玩家",
  place_bet: "下注",
  ranking: "排行",
  total_winning: "总奖金",
  first_prize: "冠军奖金",
  second_prize: "亚军奖金",
  third_prize: "季军奖金",
  participants: "参赛者",
  place: "位置",
  current_prize: "当前积分",
  next: "下一步",
  last_join_time: "最后加入时间",
  tutorial: "重播教程",
  introduction: "介绍视频",
  close: "关闭",
  jackpot: "中奖",
  prize: "奖金",
  exclusive: "独家",

  adjustment: "调整",
  poker: "扑克"
};
